import { render, staticRenderFns } from "./AuroReleaseHistory.vue?vue&type=template&id=00720804"
import script from "./AuroReleaseHistory.vue?vue&type=script&lang=js"
export * from "./AuroReleaseHistory.vue?vue&type=script&lang=js"
import style0 from "./AuroReleaseHistory.vue?vue&type=style&index=0&id=00720804&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports